import React from "react";

import clsx from "clsx";
import Image from "next/image";

import FigureImage from "public/images/enerflo-digital-welcome-calls-callpilot.png";

import HeroSection from "../../hero-section";
import styles from "./index.module.css";
import TimelineContent from "./timeline-content";

const title = "Digital Welcome Calls";

const DigitalWelcomeCalls = () => (
  <div className={clsx("timeline-section-wrapper", styles.timelineSectionWrapper)}>
    <HeroSection title={title} className={styles.timelineSection}>
      <div className={styles.timelineSectionGrid}>
        <figure className={clsx(styles.timelineFigure)}>
          <div className="mx-auto w-1/2 md:w-[120%] md:ml-[10%] lg:w-[135%] lg:ml-[-5%] xl:w-[125%] xl:ml-[10%]">
            <Image
              src={FigureImage}
              alt="Enerflo Digital Welcome Calls powered by CallPilot, a cloud-based enterprise level TPV application."
              layout="responsive"
              quality={100}
              placeholder="blur"
              className="crispImage"
              sizes="(min-width: 768px) 50vw, 100vw"
              lazyBoundary="400px"
            />
          </div>
        </figure>
        <TimelineContent
          title={title}
          description="Until now, Welcome Calls required people power to call and collect necessary information from customers for residential solar projects, often resulting in long hold times, delays, as well as transcription or recording errors. Enerflo Digital Welcome Calls powered by CallPilot change all that with fully customizable cloud-based surveys, zero hold times and a 35% reduction in overall call times, saving solar installers money and resources, while increasing customer satisfaction."
          offsetFigure
          icon={
            <Image
              src="/images/icons/digital-welcome-calls.svg"
              alt="Icon - Enerflo Digital Welcome Calls"
              layout="responsive"
              height={55}
              width={60}
              quality={100}
              className="crispImage"
            />
          }
        />
      </div>
    </HeroSection>
  </div>
);

export default DigitalWelcomeCalls;
